import {Observable, throwError as observableThrowError} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AuthenticateService } from './authenticate.service';
import {environment} from '../../environments/environment';

@Injectable()
export class TagService {

  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token
  });

  constructor(private http: HttpClient,
              private authenticationService: AuthenticateService) {
  }

  createTag(tag): Observable<any> {
    return this.http.post(environment.apiBaseUrl + 'create-evend-product-tag',
      JSON.stringify(tag),
      {headers: this.headers}).pipe(
      // ...errors if any
      catchError((error: any) => observableThrowError(error.error || 'Server error')));
  }

  updateTag(tag: any, id: string): Observable<any> {
    return this.http.put(environment.apiBaseUrl + 'update-evend-product-tag/' + id,
        JSON.stringify({evendProductTag: {
            name: tag.name
        }}),
        { headers: this.headers})
        .map((res: Response) => {
            return res;
        })
        // ...errors if any
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
}

  searchTag(text: string): Observable<any> {
    return this.http.post(environment.apiBaseUrl + 'search-evend-product-tags',
      JSON.stringify({text: text}),
      {headers: this.headers}).pipe(
      map((res: Response) => res.json()),
      catchError(() => []));
  }

  getAllTags(page: number): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'get-all-evend-product-tags/' + page,
      { headers: this.headers})
      .map((res: Response) => {
        return res;
    })
    // ...errors if any
    .catch((error: any) => Observable.throw(error.error || 'Server error'));
}

  deleteTag(id: string): Observable<any> {
    return this.http.delete(environment.apiBaseUrl + 'delete-evend-product-tag/' + id,
      {headers: this.headers}).pipe(
      // ...errors if any
      catchError((error: any) => observableThrowError(error.error || 'Server error')));
  }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/tag.service.ts